import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerInvoiceReportComponent } from './customer-invoice-report.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerInvoiceReportComponent,
    data: { title: 'Customer Invoice Report' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerInvoiceReportRoutingModule {}

@NgModule({
  imports: [
    CustomerInvoiceReportRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerInvoiceReportComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerInvoiceReportModule {}
